<template>
	<div class="thumbnail" :class="{unbd:!!unbd}">
		<slot name="img">
		</slot>
		<div class="caption">
			<slot name="caption"></slot>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			unbd:Boolean
		},
		computed:{
			
		}
	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.thumbnail{
		.unbdr;
		cursor: pointer;
		.caption:empty{
			.pd(0);
		}
		.trs;
		-webkit-transform: scale(1);
		-moz-transform: scale(1);
		-ms-transform: scale(1);
		-o-transform: scale(1);
		transform: scale(1);
		&:hover{
			-webkit-transform: scale(1.02);
			-moz-transform: scale(1.02);
			-ms-transform: scale(1.02);
			-o-transform: scale(1.02);
			transform: scale(1.02);
		}
		&.unbd{
			.unbd;
		}
	}
</style>


// WEBPACK FOOTER //
// thumbnail.vue?04dc4bff